import { Entity } from '@data-client/rest';
class OrganizationLicenseTypeEntity extends Entity {
    constructor() {
        super(...arguments);
        this.authoredDecryptsAllowed = false;
        this.decryptsAllowed = false;
        this.encryptsAllowed = false;
        this.genealogyEncryptsAllowed = false;
        this.isDefault = false;
        this.name = null;
        this.organizationId = 0;
        this.organizationLicenseTypeId = 0;
    }
    pk() {
        return this.organizationLicenseTypeId.toString();
    }
}
OrganizationLicenseTypeEntity.key = 'OrganizationLicenseType';
export { OrganizationLicenseTypeEntity };
